import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { DataTable } from 'components/data-table';

type WarningRow = { id: string; message: string } & Record<string, unknown>;

const columnHelper = createColumnHelper<WarningRow>();

const columns = [
  columnHelper.accessor('message', {
    id: 'message',
    header: 'Warning',
    size: 600,
    meta: { type: 'text' },
  }),
];

const CalculationWarnings = ({ warnings }: { warnings: string[] }) => {
  const rows: WarningRow[] = warnings.map((msg, i) => ({
    id: String(i),
    message: msg,
  }));

  return (
    <DataTable
      data={rows}
      columns={columns as ColumnDef<WarningRow>[]}
      getRowId={(row) => row.id}
      persistenceKey="evaluation-result-calculation-warnings"
      config={{
        sorting: true,
        globalSearch: true,
        columnFilters: true,
        columnResizing: true,
        export: {
          exportPresets: [
            {
              name: 'Export',
              format: 'csv',
              filename: 'calculation-warnings',
            },
          ],
        },
      }}
    />
  );
};

export { CalculationWarnings };
